import { cn } from "@/lib/utils";
import { Inbox } from "lucide-react";

/**
 * EmptyState — konsisten untuk list kosong.
 * icon default = Inbox. Pass custom icon via `icon` prop.
 */
export const EmptyState = ({ icon: Icon = Inbox, title = "Belum ada data", description, action, className, testid }) => (
    <div
        className={cn("flex flex-col items-center justify-center text-center py-12 px-4", className)}
        data-testid={testid || "empty-state"}
    >
        <div
            className="w-14 h-14 rounded-full flex items-center justify-center mb-3"
            style={{ background: "var(--bg-subtle)", border: "1px solid var(--border-soft)" }}
        >
            <Icon className="w-6 h-6" style={{ color: "var(--text-muted)" }} />
        </div>
        <div className="text-sm font-medium mb-1" style={{ color: "var(--text-primary)" }}>
            {title}
        </div>
        {description && (
            <div className="text-xs max-w-xs" style={{ color: "var(--text-muted)" }}>
                {description}
            </div>
        )}
        {action && <div className="mt-4">{action}</div>}
    </div>
);

export default EmptyState;
